import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";
import * as inputTypes from "components/Forms/InputTypes";

/**
 * options for formErrorClass:
 * form-error (default)
 * form-error-inverse
 *  */
function Textbox({
  id,
  name,
  errors,
  errorKey,
  type = inputTypes.TEXTBOX,
  classes = "",
  placeholder = "",
  fieldValue = "",
  autoComplete = "on",
  onChange,
  onReturnKey,
  onClick = () => {},
  onBlur = () => {},
  onFocus = () => {},
  onKeyUp = () => {},
  formErrorClass = "form-error"
}) {
  const [formError, setFormError] = useState("");
  const [readOnly, setReadOnly] = useState(true);
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors.length") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
          break;
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <span>
      <input
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        value={fieldValue}
        autoComplete={autoComplete}
        readOnly={readOnly}
        onMouseEnter={e => setReadOnly(false)}
        onFocus={e => {
          setReadOnly(false);
          onFocus(e);
        }}
        className={`form-input ${classes} ${formError}`}
        onChange={e => {
          onInputChange(e);
          onChange(e);
        }}
        onBlur={e => onBlur(e)}
        onClick={e => onClick(e)}
        onKeyUp={e => {
          if (e.which === 13 && onReturnKey) onReturnKey();
          onKeyUp(e);
        }}
      />
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </span>
  );
}

Textbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onReturnKey: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyUp: PropTypes.func,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  type: PropTypes.string,
  classes: PropTypes.string,
  placeholder: PropTypes.string,
  fieldValue: PropTypes.any,
  autoComplete: PropTypes.string,
  formErrorClass: PropTypes.string
};

export default Textbox;
